import { Box } from '@factorialco/deprecated-design-system'
import { Spinner } from '@factorialco/deprecated-design-system'
import { ItemIntegrationFragment } from 'generated/resources/graphql'

import { usePaywall } from 'modules/marketplace/hooks/usePaywall'

import { InstallationButton } from './InstallationButton'
import { UpsellModal } from './UpsellModal'

interface ItemData {
  integration: ItemIntegrationFragment
}

export const InstallWorkflow = ({ integration }: ItemData) => {
  const { showPaywall, loading } = usePaywall(integration)

  if (loading) return <Spinner />

  return (
    <Box>
      {showPaywall ? (
        <UpsellModal integration={integration} />
      ) : (
        <InstallationButton integration={integration} />
      )}
    </Box>
  )
}
